import { register, find } from '../../../../Javascript/Sysmex/Utils'

const Checkbox = el => {
  const reloadUrl = el.dataset.reloadurl
  const componentPrefix = el.dataset.componentprefix
  const submitOnChange = el.dataset.submitonchange

  if (!reloadUrl && !submitOnChange) {
    return false
  }

  const checkbox = find(`.${componentPrefix}checkboxField`, el)
  checkbox.addEventListener('change', (e) => {
    if (submitOnChange) checkbox.form.requestSubmit()
    if (reloadUrl) window.location.href = reloadUrl
  })
}

register('Checkbox', Checkbox)
